<template>
<div class="dashboard-widget-tabs p-0">
	<div class="dashboard-widget-tabs-content mb-0 p-15">
		<h2>
			<i class="uil uil-bookmark-full"></i>
			نشان‌شده‌ها
		</h2>
		<div class="dashboard-widget-h-btns">
			<a href="" @click.prevent="showSidebar('list')" class="m-left m-top tgju-btn tgju-btn-primary t-display-inline-block d-w-min-hide" v-tooltip="'علاقه‌مندی‌ها'"><i class="uil uil-bookmark-full"></i> <span class="hide-m-min"> علاقه‌مندی‌ها </span></a>				
			<a v-if="!widgetLoad" href="" @click.prevent="open_favorite_add_modal()" class="m-left m-top tgju-btn tgju-btn-primary" :class="{'t-display-none': sidebarShow == true}" v-tooltip="'افزودن لینک'"><i class="uil uil-plus-circle"></i> <span class="hide-m-min">افزودن لینک </span></a>				
		</div>
	</div>

	<div class="sidebar-box">
		<slot v-if="widgetLoad">
			<div class="tgju-widget-content full-padding">
				<div class="text-center p-2">
					<div class="widget-loading"></div>
				</div>
			</div>		
		</slot>
		<slot v-else>
			<div class="content-box fix-content">

				<div class="list-row l-head">
					<div class="list-col l-title">
						<span v-if="activeFavorite">مشاهده فهرست‌ {{ activeFavorite.title }}</span>
					</div>
				</div>

				<div class="tgju-widget-content full-padding">
					<div class="list-widget-search-container">
						<i class="fa fa-search list-widget-search-icon" aria-hidden="true"></i>
						<input class="list-widget-search" type="text" placeholder="جستجو در لینک‌ها ..." v-model="searchQueryLink">
					</div>
					<slot v-if="!activeFavorite || activeFavorite.links.length == 0">
						<div class="popup-dash-empty">
							<i class="uil uil-exclamation" aria-hidden="true"></i>
							<span>مقداری برای نمایش وجود ندارد</span>
						</div>
					</slot>
					<slot v-else>
						<slot v-if="activeFavorite">
							<div class="list-widget list-dash-items list-widget-structure">
								<draggable v-model="activeFavorite.links" group="favoriteslinks" @start="drag=true" @end="saveFavoriteLinkSort()" ghost-class="drag-ghost">
									<template v-for="link in filteredLinks">
										<div :key="link.id" class="list-row item-draggable hover bold">
											<div class="list-col l-item pointer" v-tooltip="'جابجایی'">
												<i class="uil uil-arrows-v list-drag"></i>
											</div>
											<div class="list-col l-title l-title-widget-structure" @click="openLink(link.id)">
												<span>{{ link.title }}</span>
											</div>
											<div class="list-col l-item blue-color pointer" @click="open_favorite_add_modal(link.id)">
												<i class="uil uil-edit-alt" v-tooltip="'ویرایش'"></i>
											</div>
											<div class="list-col l-item red-color pointer" @click="removeFavoriteLink(link.id)">
												<i class="uil uil-trash remove-row" v-tooltip="'حذف'"></i>
											</div>
										</div>
									</template>
								</draggable>
							</div>
						</slot>
						<slot v-else>
							<div class="text-center p-2">
								<div class="widget-loading"></div>
							</div>
						</slot>
					</slot>
			
				</div>
			</div>

			<div class="c-sidebar fix-sidebar" :class="{'t-display-none': sidebarShow == false}">
				<div class="sidebar-title-row t-display-block-flex">
					<h3></h3>
					<i class="uil uil-times pointer" @click.prevent="hideSidebar()"></i>
				</div>
				<input class="widget-input m-top w-100" type="text" placeholder="جستجو در فهرست‌ها" v-model="searchQuery">
				<div class="list-widget list-dash-items list-widget-structure" data-list-type="favorite-cat">
					<draggable v-model="favorites" group="favorites" @start="drag=true" @end="saveFavoritesSort()" ghost-class="drag-ghost" v-if="favorites">
						<template v-for="favorite in filteredList">
							<div :key="favorite.id" :class="'list-row item-draggable hover bold ' + (activeFavorite.id  == favorite.id? 'active-item' : '')">
								<div class="list-col l-item pointer" v-tooltip="'جابجایی'">
									<i class="uil uil-arrows-v list-drag"></i>
								</div>
								<div class="list-col l-title l-title-widget-structure" @click="openFavorite(favorite.id); makeResponsive(2)">
									<span>{{ favorite.title }}</span>
								</div>
								<div class="list-col l-item pointer"  @click="open_favorite_edit_modal(favorite.id)">
									<i class="uil uil-edit-alt" v-tooltip="'ویرایش'"></i>
								</div>
								<div class="list-col l-item red-color pointer" @click="removeFavorite(favorite.id)">
									<i class="uil uil-trash remove-row" v-tooltip="'حذف'"></i>
								</div>
							</div>
						</template>
					</draggable>
					<div :class="'list-widget-add-container border-0 border-top-1 ' + (addEditLoading ? 'loading-active' : '') ">
						<i class="fa fa-plus list-widget-add-icon" v-tooltip="'افزودن فهرست جدید'" aria-hidden="true" @click="addFavorite()"></i>
						<input class="list-widget-input-add" type="text" placeholder="افزودن فهرست جدید" v-model="newFavorite" @keyup.enter="addFavorite()">
					</div>
				</div>
			</div>
		</slot>
	</div>

</div>
</template>

<style lang="scss">
	.widget-min-box-content {
		.l-title {
			display: flex;
		}
		.edit-favorite {
			font-size: 14px;
			cursor: pointer;
			margin-right: -3px;
		}
	}
</style>

<script>
	// این کامپوننت دارای اجزا و کنترلر های مربوط به نشان شده ها یا علاقه مندی ها می باشد
	import draggable from 'vuedraggable'

	export default {
		name: 'Favorite',
		props: ['widget', 'data', 'editable', 'wrapper'],
		components: {
			draggable
		},
		data() {
			return {
				sidebarShow: false,
				favorites: [],
				activeFavorite: undefined,
				newFavorite: '',
				searchQuery:'',
				searchQueryLink:'',
				responsive: {
					rightSection: true,
					leftSection: false,
					leftPanel: false,
				},
				widgetLoad: true,
				addEditLoading: false,
			}
		},

		mounted() {
			this.$watch('data', function(newValue, oldValue) {
				if ( Object.keys(newValue).length && ( typeof oldValue == 'undefined' || !Object.keys(oldValue).length ) ) {
					// تزریق داده های ورود به کامپوننت
					this.loadData();
				}
			}, {immediate: true});
		},
		computed: {
			// فیتلر سازی لیست های علاقه مندی ها
			filteredList() {
					return this.favorites.filter(favorite => {
					return favorite.title.toLowerCase().includes(this.searchQuery.toLowerCase()
				)}
			)},
			// فیتلر سازی لینک های و یا ایتم های علاقه مندی ها
			filteredLinks() {
					return this.activeFavorite.links.filter(link => {
					return link.title.toLowerCase().includes(this.searchQueryLink.toLowerCase()
				)}
			)},
		},
		methods: {		
			// این تابع وظیفه تزریق داده های ورودی به کامپوننت را دارد	
			loadData() {
				this.favorites = this.data.favorites;

				if ( this.favorites.length ) {
					this.activeFavorite = this.favorites[0];
				}

				this.widgetLoad = false;
			},
			// این متد وظیفه ی حذف یک علاقه مندی و یا نشان شده را دارد
			removeFavorite(id) {

				this.$helpers.confirm('هشدار حذف!', {
					message: 'آیا از حذف این مورد اطمینان دارید؟',
				}).then((confirmed) => {
					if ( confirmed ) {
						
						this.activeFavorite = undefined;

						let index = this.$helpers.getIndex(this.favorites, id);

						this.favorites.splice(index, 1);
						
						let next_index = index - 1;
						if ( next_index < 0 ) 
							next_index = 0;

						if(this.favorites.length > 0) {
							this.openFavorite(this.favorites[next_index].id);
						}

						this.$helpers.makeRequest('DELETE', '/favorite/delete/' + id).then(api_response => {
							this.$helpers.api_alert(api_response);

							if ( api_response.status == 200 ) {
								this.$swal.fire({
									icon:"success",
									title:"فهرست با موفقیت حذف شد",
									showConfirmButton:!1,
									timer:2000
								});
								this.showSidebar();
							} else {
								this.$swal.fire({
									icon:"error",
									title:"مشکلی در حذف فهرست رخ داده است",
									showConfirmButton:!1,
									timer:2000
								});
							}
						});	
					}
				});
			},
			// این متد وظیفه این را دارد پس از کلیک روی علاقه مندی مورد نظر آیتم های آن را لود میکند
			openFavorite(id) {
				let index = this.$helpers.getIndex(this.favorites, id);

				this.activeFavorite = this.favorites[index];
				this.sidebarShow = false;
			},
			// این متد وظیفه ایجاد علاقه مندی جدید را دارد و ارسال درخواست به سرور جهت ثبت در دیتابیس را دارد
			addFavorite() {
				if ( !this.newFavorite ) return;

				let id = 'id-' + new Date().getTime();
				this.addEditLoading = true;

				this.favorites.push({
					id,
					title: this.newFavorite,
					links: []
				});

				let api_data = {
					title: this.newFavorite,
					links: null,
				};

				this.$helpers.makeRequest('POST', '/favorite/save', api_data).then(api_response => {
					this.$helpers.api_alert(api_response);

					if ( api_response.status == 200 ) {
						let inserted_id = api_response.data.response.id;

						this.favorites.forEach((favorite, index) => {
							if ( favorite.id == id ) {
								favorite.id = inserted_id;
							}
						});
						this.$swal.fire({
							icon:"success",
							title:"فهرست با موفقیت ایجاد شد",
							showConfirmButton:!1,
							timer:2000
						});
						this.addEditLoading = false;
					}else{
						this.$swal.fire({
							icon:"error",
							title:"مشکلی در ایجاد فهرست رخ داده است",
							showConfirmButton:!1,
							timer:2000
						});
						this.addEditLoading = false
					}
				});
					

				this.newFavorite = '';
				this.openFavorite(id);
			},
			// این متد جهت هندل سورت کردن و ترتیب قرار گیری ایتم های لیست علاقه مندی ها استفاده میشود
			saveFavoritesSort() {
				let sort = [];
				this.favorites.forEach(favorite => {
					sort.push(favorite.id);
				});

				let api_data = {
					sort: JSON.stringify(sort),
				};

				this.$helpers.makeRequest('POST', '/favorite/sort', api_data).then(api_response => {
					this.$helpers.api_alert(api_response);

					if ( api_response.status == 200 ) {
						Vue.prototype.$toast.success({
							title : 'ذخیره',
							message : 'مرتب سازی با موفقیت ذخیره شد',
						});
					}else{
						Vue.prototype.$toast.warn({
							title : 'ذخیره',
							message : 'مشکلی در مرتب سازی رخ داده است',
						});
					}
				});
			},
			// این متد برای ذخیره سازی ترتیب لینک های علاقه مندی استفاده میشود
			saveFavoriteLinkSort() {
				this.saveFavoriteLink();
			},
			// این متد برای حذف یک لینک علاقه مندی استفاده میشود
			removeFavoriteLink(id) {
				let index = this.$helpers.getIndex(this.activeFavorite.links, id);

				this.activeFavorite.links.splice(index, 1);

				this.saveFavoriteLink('delete');
			},
			// این متد برای ذخیره سازی یک لینک در علاقه مندی انتخاب شده و مورد نظر استفاده میشود
			saveFavoriteLink(action = null) {
				let api_data = {
					links: JSON.stringify(this.$helpers.unbindObject(this.activeFavorite.links)),
				};

				this.$helpers.makeRequest('POST', '/favorite/link-save/' + this.activeFavorite.id, api_data).then(api_response => {
					this.$helpers.api_alert(api_response);

					if ( api_response.status == 200 ) {
						if( action == 'editLink' ) {
							this.$swal.fire({
								icon:"success",
								title:"لینک با موفقیت ویرایش شد",
								showConfirmButton:!1,
								timer:2000
							});
						} else if( action == 'addLink' ) {
							this.$swal.fire({
								icon:"success",
								title:"لینک با موفقیت ایجاد شد",
								showConfirmButton:!1,
								timer:2000
							});
						} else if( action == 'delete' ) {
							this.$swal.fire({
								icon:"success",
								title:"لینک با موفقیت حذف شد",
								showConfirmButton:!1,
								timer:2000
							});
						}
					} else {
						if( action == 'editLink' ) {
							this.$swal.fire({
								icon:"error",
								title:"مشکلی در ویرایش لینک رخ داده است",
								showConfirmButton:!1,
								timer:2000
							});
						} else if( action == 'addLink' ) {
							this.$swal.fire({
								icon:"error",
								title:"مشکلی در ایجاد لینک رخ داده است",
								showConfirmButton:!1,
								timer:2000
							});
						} else if( action == 'delete' ) {
							this.$swal.fire({
								icon:"error",
								title:"مشکلی در حذف لینک رخ داده است",
								showConfirmButton:!1,
								timer:2000
							});
						}
					}
				});
			},
			// این متد پس از کلیک روی لینک مورد نظر آن را در تب جدید باز میکند
			openLink(id) {
				let index = this.$helpers.getIndex(this.activeFavorite.links, id);

				window.open(this.activeFavorite.links[index].url);
			},
			// این متد وظیفه هندل کردن مودال تنظیمات علاقه مندی در ویجت داشبورد است
			open_settings_modal() {
				let callbackEvent = this.$router.currentRoute.name + '_save_settings_' + this.widget.id + '_' + new Date().getTime();

				let modal_data = {
					modal: 'widget_settings_modal',
					callbackEvent,
					component: 'Settings/Favorite.vue',
					config: {
						data: {
							title: this.widget.title,
						}
					}
				};

				modal_data = this.$helpers.unbindObject(modal_data);

				this.$root.$emit('open_modal', modal_data);

				this.$root.$on(callbackEvent, (settings) => {
					this.widget.title = settings.title;

					let widget = this.$helpers.unbindObject(this.widget);

					this.$helpers.saveWidget(widget);
				});
			},
			// این متد وظیفه ی باز کردن مودال و هندل کردن کال بک مودال جهت ایجاد لینک جدید در علاقه مندی ها می باشد
			open_favorite_add_modal(id = null) {
				let callbackEvent = this.$router.currentRoute.name + '_AddLinks_' + new Date().getTime();

				let action = ( id ) ? 'edit' : 'add';
				let link = null;

				if ( id ) {
					let index = this.$helpers.getIndex(this.activeFavorite.links, id);
					link = this.activeFavorite.links[index];
				}

				let modal_data = {
					modal: 'general_modal',
					callbackEvent,
					component: 'FavoriteAdd.vue',
					config: {
						title: ( action == 'edit' ) ? 'ویرایش لینک' : 'افزودن لینک',
						icon: ( action == 'edit' ) ? 'uil uil-edit-alt with-icon' : 'uil uil-plus-circle with-icon',
						smallModal: true,
						data: {
							action,
							link,
						},
					}
				};

				this.$root.$emit('open_modal', modal_data);
				// هندل کردن کال بک
				this.$root.$on(callbackEvent, (response) => {
					if ( response.action == 'addLink' ) {
						this.activeFavorite.links.push({
							id: 'id-' + new Date().getTime(),
							title: response.data.link.title,
							url: response.data.link.url,
						});
						this.saveFavoriteLink('addLink');
					} else if ( response.action == 'editLink' ) {
						link.title = response.data.link.title;
						link.url = response.data.link.url;

						this.saveFavoriteLink('editLink');
					}
				});
			},
			// این متد وظیفه ی باز کردن مودال و هندل کردن کال بک مودال جهت ویرایش لینک  در علاقه مندی ها می باشد
			open_favorite_edit_modal(id = 0) {

				if (id > 0) {
					let index = this.$helpers.getIndex(this.favorites, id);
					this.activeFavorite = this.favorites[index];
				}

				let callbackEvent = this.$router.currentRoute.name + '_EditFavorites_' + new Date().getTime();

				let modal_data = {
					modal: 'general_modal',
					callbackEvent,
					component: 'FavoriteEdit.vue',
					config: {
						title: 'ویرایش فهرست علاقه‌مندی',
						icon:'uil uil-edit-alt with-icon',
						smallModal: true,
						data: {
							favorite: this.$helpers.unbindObject(this.activeFavorite),
						},
					}
				};

				this.$root.$emit('open_modal', modal_data);
				
				// هندل کردن کال بک
				this.$root.$on(callbackEvent, (response) => {
					if ( response.action == 'editFavorite' ) {
						this.activeFavorite.title = response.data.favorite.title;

						let api_data = {
							title: this.activeFavorite.title,
						};
						// ارسال درخواست به سرور
						this.$helpers.makeRequest('POST', '/favorite/edit/' + this.activeFavorite.id, api_data).then(api_response => {
							this.$helpers.api_alert(api_response);

							if ( api_response.status == 200 ) {
								this.$swal.fire({
									icon:"success",
									title:"فهرست با موفقیت ویرایش شد",
									showConfirmButton:!1,
									timer:2000
								});
							} else {
								this.$swal.fire({
									icon:"error",
									title:"مشکلی در ویرایش فهرست رخ داده است",
									showConfirmButton:!1,
									timer:2000
								});
							}
						});
					}
				});
			},

			makeResponsive(mode) {
				if ( mode == 1 ) {
					this.responsive.rightSection = true;
					this.responsive.leftSection = false;
				} else if ( mode == 2 ) {
					this.responsive.rightSection = false;
					this.responsive.leftSection = true;
				}
			},
			
			showSidebar(){
				this.sidebarShow = true;
			},
			hideSidebar(){
				this.sidebarShow = false;
			}
		}
	}
</script>